module.exports = __webpack_public_path__ + "img/1-m.c8451475.jpg";